import BaseContent from '@model/content/BaseContent'

class Info extends BaseContent {
    constructor(object) {
        super(object)
    }

    isSchedulableOnSecondaryJourney() {
        return true
    }
}

export default Info
